import { initializeApp } from 'firebase/app'
import 'firebase/remote-config'

// export default initializeApp({
const app = initializeApp({
  apiKey: 'AIzaSyBAT27hXPgCP2KF361DUYiDPb3lUE17Ht8',
  authDomain: 'jelp-delivery-tracker.firebaseapp.com',
  projectId: 'jelp-delivery-tracker',
  storageBucket: 'jelp-delivery-tracker.appspot.com',
  messagingSenderId: '699033280124',
  appId: '1:699033280124:web:ce8b0a583f584e405b33f9',
  measurementId: 'G-SGKF3MWP0Z'
})

export default app

